enum Alpha{
    DEFAULT= 0.6,
    LIGHT=0.3
}

export default {
    image: {
        MAX_REQUEST_HEIGHT: 720,
    },
    json: {
        DEFAULT_ATTRIBUTES: {},
        DEFAULT_LABELS: {},
        COLORS: {}
    },
    gallery: {
        MAX_IMAGE_SIZE: 8,
        DELAY_TIME: 400
    },
    uploadTimeOut: {
        NUMBER_OF_RETRIES: 4,
        TIME_RETRY: 60000,
        TIME_DELAY_BASIC: 2000,
        TIME_DELAY_CHUNK: 10000,
        NUMBER_OF_CHUNKS: 5
    },
    hitl: {
        IME_DELAY_BASIC: 60000
    },
    canvasConfig: {
        DEFAULT_RADIUS: 7,
        DEFAULT_ANCHORS_RADIUS: 7,
        DEFAULT_LINE_PRESS: 3,
        DEFAULT_LINE_POINT: 2,
        STROKE_STYLE: '#FFFFFF',
        Alpha
    },
    sliders: {
        blur: Array.from(Array(16).keys()).filter((v) => (v % 2 === 1)).map((v:any) => v = {value: v, label: `${v}`}),
        dilat: Array.from(Array(14).keys()).filter((v) => (v % 2 === 1)).map((v:any) => v = {value: v, label: `${v}`})
    }
};


